import { useMutation } from "@apollo/client/react";
import { DSCircularButton } from "@components/design-system/molecules";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { usePimsExportFormat } from "@hooks";
import React from "react";
import { useLocation } from "react-router";

import { copyAll } from "./utils";
import MARK_NOTES_EXPORTED from "../../../graphql/mutations/MarkNotesExported";

function CopyFullSOAP({
  note,
  refetch = null,
  isForSharedExport = false,
}) {
  const [modifyNotes] = useMutation(MARK_NOTES_EXPORTED);
  const pimsFormat = usePimsExportFormat();
  const location = useLocation();

  if (note) {
    const isDisabled =
      note?.isNewRecording ||
      note?.isMarkedAsProcessing ||
      note?.isMarkedAsFailed;

    return (
      <DSCircularButton
        title="Copy entire note"
        icon={faCopy}
        size="sm"
        variant="primary"
        disabled={isDisabled}
        onClick={() => {
          copyAll({ note, isForSharedExport, format: pimsFormat });

          if (!isForSharedExport) {
            modifyNotes({
              variables: {
                noteUuids: [note.uuid],
                action: "mark_exported",
              },
            });

            if (location.pathname == "/inbox") {
              refetch({});
            } else {
              if (refetch !== null) {
                refetch({ isApproved: true });
              }
            }
          }
        }}
        dataTestId={`copy-entire-${note?.jobTypeName}-button`}
      />
    );
  } else {
    return null;
  }
}

export default CopyFullSOAP;
